import AOCollection from './AOCollection';
import dataModel from '../../models/DataModel';
import ReduxConstants from '../../constants/ReduxConstants';
import projectAnalysisService from '../../services/projectAnalysisService';

// For now, we always want to fetch the same level of data for this collection
const analysisProjectDescriptor = {
  analysis_project: {
    analysis_completion_criteria: {},
  },
};

export default class ProjectAnalysisCollection extends AOCollection {
  /**
   * @param {object} filter - has the following properties:
   *  - projectTemplateId (number)
   *  - projectName (string) - project name search string 
   *  - projectStatuses (string) - comma delimited list of statuses (e.g. 'not_started,in_progress')
   */
  constructor(perPage, filter, userId, companyId, subKey) {
    super({
      name: ReduxConstants.PROJECTS_ANALYSIS,
      collectionType: 'ANALYSIS_PROJECT', // TODO: finalize this
      perPage,
      filter,
      userId,
      companyId,
      subKey,
      recordDescriptor: analysisProjectDescriptor,
    });
  }

  static build(perPage, filter, userId, companyId, subKey) {
    const collection = new ProjectAnalysisCollection(perPage, filter, userId, companyId || localStorage.current_company_id, subKey);
    const collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collection._recordState = '';
      dataModel.collectionsDAO.setCollection(collection.getKey(), collection.getData(), collection.getCollectionType(), analysisProjectDescriptor);
    }
    else {
      collection._filter = collectionData._filter;
      collection.ids = collectionData.ids;
      collection.page = collectionData.page ? collectionData.page : 1;
      collection.perPage = collectionData.perPage ? collectionData.perPage : perPage;
      collection.meta = collectionData.meta;
      collection.recordDescriptor = collectionData.recordDescriptor;
    }
    return collection;
  }

  handleOffLineFetch(options) {
    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection);
    });
  }

  async fetchCurrent(shouldPaginate = true, options = {}) {

    let marketIds = await dataModel.usersDAO.getEditorUserMarkets(this.userId ? this.userId : dataModel.usersDAO.currentUser.id);

    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      let collection = this.findCollection();

      let page = null;
      let perPage = null;
      
      // Get everything we already got
      if (shouldPaginate) {
        page = 1;
        if (collection && collection.perPage) {
          perPage = Math.max(this.perPage, collection.ids.length);
        }
      }
      
      const { projectTemplateId, projectName, projectStatuses } = this._filter;
      const options = { 
        projectName, 
        projectStatuses,
        page, 
        perPage,
        recordDescriptor: analysisProjectDescriptor,
        marketIds,
      };
      const serviceCall = projectAnalysisService.getProjectAnalysis.bind(this, projectTemplateId, options);

      let newCollection = await this._fetchData(serviceCall, options);
      return newCollection;
    }
  }

  // template - could put in meta or do custom processing
  // projects - use some alreadyDenormalized option?

  async fetchNext(pageOverride, options = {}) {

    let marketIds = await dataModel.usersDAO.getEditorUserMarkets(this.userId ? this.userId : dataModel.usersDAO.currentUser.id);

    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor ? this.recordDescriptor : analysisProjectDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      if (pageOverride) {
        this.page = pageOverride;
      }
      else this.page++;

      const { projectTemplateId, projectName, projectStatuses } = this._filter;
      const seviceOptions = { 
        projectName, 
        projectStatuses, 
        page: this.page, 
        perPage: this.perPage,
        recordDescriptor: analysisProjectDescriptor,
        marketIds,
      };
      const serviceCall = projectAnalysisService.getProjectAnalysis.bind(this, projectTemplateId, seviceOptions);
      const newCollection = await this._fetchData(serviceCall, options, true);
      return newCollection;
    }
  }

}



// WEBPACK FOOTER //
// ./src/dao/collections/ProjectAnalysisCollection.js